import { Injectable } from '@angular/core';
import { ApiBaseService } from './api.base.service';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class templateServices extends ApiBaseService {
    constructor(public http: HttpClient) {
        super(http, '/templates');
    }

    checkNameExists(name: string, id?: boolean | number): Observable<any> {
        const templateId = id ? id : null;
        const params = { name, templateId };
        return this.http.get(`${environment.apiUrl}/templates/check`, {
            params,
        });
    }


    deleteFile(data: any): Observable<any> {
        return this.http.post(`${environment.apiUrl}/templates/deleteFile`,data);
    }
}
